/*获取或处理初始化地图所需数据或状态预设*/
import Qs from "qs"
import $request from '../utils/request.js'
import {HOST,WXUSERHOST,mapEventManger,mapFunManger} from "./config.js";
import {getParam,$system,getAjax} from '../utils/util.js'
import {dataCHTOEN} from "../../../en/src/utils/search_poi_extend";

/*
* 地图初始化方式（通过接口拿到所需的数据,现有方式如下：）
* 1.url地址栏传signa,通过/api/getPlugins接口Get请求
* 2.直接通过/api/getSystemInfo接口Get请求
* 3.注：主要看后台怎么提供，怎么提供怎么玩
* */

let $smsVarUrl = HOST + '/api/v1/verifyCode',
    $smssendUrl = HOST + '/api/v1/sendSms',

    $queryPlateUrl = HOST,
    $queryEmptySpacesUrl=HOST,
    $querySpacesTotalUrl=HOST;

export function getPlugInfo(callback) {

    //getParam('sign')123456 b39b2e9d981e4ba281dd440fd3afec77
    let $pluginInfo, locationSign = getParam('sign') || 'd5e026d3d93741198b8e7af68aa9c061', cacheSign = sessionStorage.getItem('sign');//不能使用sign与其他部分冲突

    //刷新需要更改的值
    let $resfreshChange = ($pluginInfo)=>{

        let $locationSign = locationSign ? locationSign : cacheSign;

        // console.log('$locationSign',$locationSign);

        let _callback = ()=>{

            //登陆处理
            let phone = window.localStorage.getItem('phone');
            $pluginInfo.phone = phone ? phone :'';

            //更改设置
            sessionStorage.setItem('sign', $locationSign);
            sessionStorage.setItem('pluginInfo', JSON.stringify($pluginInfo));

            callback && callback($pluginInfo);

        }

        //获取基础设置信息
        $request.get(HOST + '/api/v1/g_Settings?sign='+$locationSign).then(($res)=>{

            if($res.data.code == 0){

                $pluginInfo.plugInfo.plugInSettings =  $res.data.result;
                $pluginInfo.plugInfo.plugInSettings.findCar = null;
                // 接入超管设置

                //地址容错处理
                let apply = $res.data.result.apply;

                if(apply && JSON.parse(apply).buildingAddress){
                    $pluginInfo.plugInfo.address = JSON.parse(apply).buildingAddress
                }

                // sms
                if($res.data.result.smsServiceOpen == 1 && $res.data.data.smsService){

                    //发送
                    $smssendUrl = $res.data.data.smsService.sendUrl;
                    //校验
                    $smsVarUrl = $res.data.data.smsService.verifyUrl;
                }

                //寻车接口(暂未提供)
                if($res.data.result.queryCarServiceOpen == 1 && $res.data.data.queryCarService){

                    //查车
                    $queryPlateUrl = $res.data.data.queryCarService.queryPlateUrl;
                    //查找空车位
                    $queryEmptySpacesUrl = $res.data.data.queryCarService.queryEmptySpacesUrl;
                    //查总车位
                    $querySpacesTotalUrl = $res.data.data.queryCarService.querySpacesTotalUrl;

                    //设置融入超管寻车
                    $pluginInfo.plugInfo.plugInSettings.findCar  = $res.data.data.queryCarService;
                }

            }

            _callback();

        }).catch((err)=>{
            _callback();
        })

    }

    if(locationSign) {

        if(locationSign !== cacheSign) {

            $request.get(HOST + '/api/v1/getBuildInfo?sign='+locationSign).then((res)=>{

                if (res.data.code == 0) {

                    //请求成功
                    $pluginInfo = {};
                    $pluginInfo.sign = locationSign;
                    $pluginInfo.appId = res.data.result.wxAppid;
                    $pluginInfo.token = res.data.result.token; //'1feaf1bc866548e28939371fb750587e'
                    $pluginInfo.buildingId = res.data.result.buildingId;
                    $pluginInfo.plugInfo = res.data.result;

                    /********异步对缓存存入导致的问题 刷新数据丢失*********/
                    $resfreshChange($pluginInfo)

                }
                else {
                    console.error(res.data.message);
                }

            })
                .catch(function (error) {
                    console.error(error);
                });
        }


        else {

            let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo'));


            $pluginInfo ? $resfreshChange($pluginInfo) : ''


        }
    }

    else {


        let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo'));

        $pluginInfo ? $resfreshChange($pluginInfo) : console.log('缺少sign');

    }
}



/*
* 创建地图
* */
export function createMap(res) {

    let $map,
        $container,
        $search,
        // $location,
        // brtmap = window.brtmap,
        width = window.innerWidth,
        height = window.innerHeight;

    $container = document.createElement('div');

    $container.style.width = '100%';
    $container.style.height = '100%';

    // console.log('res',JSON.parse(res.plugInfo.plugInSettings.map).floor);

    $map = new brtmap.Map({
        container: $container,
        width: width,
        height: height,
        token: res.token,
        buildingID: res.buildingId,
        floorID: res.plugInfo.plugInSettings && JSON.parse(res.plugInfo.plugInSettings.map).floor ? JSON.parse(res.plugInfo.plugInSettings.map).floor : null,
        pitch: res.plugInfo.plugInSettings && JSON.parse(res.plugInfo.plugInSettings.map).inclineAngle >= 0 ? JSON.parse(res.plugInfo.plugInSettings.map).inclineAngle : 30,
        bearing:res.plugInfo.plugInSettings && JSON.parse(res.plugInfo.plugInSettings.map).rotateAngle >= 0 ? JSON.parse(res.plugInfo.plugInSettings.map).rotateAngle : 30,
        report: false,
        antialias:false,
        logoPosition: 'hidden',
        floorPosition: 'hidden',
        zoomPosition: 'hidden',
        labelPadding:20,
        loadSyncRoutes:false
    });

    //初始化搜索功能模块
    $search = new brtmap.Search().addTo($map);

    $search.on('ready',()=>{

        mapEventManger.mapQueryStatus = true;

        if(mapEventManger.mapQueryEvents.length){

            for(let i=0;i<mapEventManger.mapQueryEvents.length;i++){
                let callback = mapEventManger.mapQueryEvents[i];
                callback && callback();
            }

            mapEventManger.mapQueryEvents = [];
        }

    })

    //更改标题
    document.title = res.plugInfo.name;

    // let $dealT = $system() == 2 ? 1000 : 3000;

    //定位版块
    window.$brtmapLocate = new brtloc.Location({
        token:res.token,
        buildingID:res.buildingId,
        report:true,        //定位上报
        inertance:true,     //定位惯性(本地部署需关掉这个，可能不支持)
    })



    //监听显示重置定位缓存（小程序切换定位不准处理）
    document.addEventListener('visibilitychange',(e)=>{
        if(document.visibilityState !='hidden'){
            $brtmapLocate.reset();
        }
    })

    let obj = {
        map: $map,
        container: $container,
        brtmapSearch: $search,
        // brtmapLocate:$location
    }

    // $map.on('mapready',()=>{    //保证地图准备完毕
    //     callback && callback(obj)
    // })

    return obj
}


/*
* 创建qq地图
* */
export function createQQMap(){

    let map,
        qqMapEvent = qq.maps.event,
        container = document.createElement('div'),
        centerLatlng = new qq.maps.LatLng(22.696525709732366,113.77490758895874), //经纬度{lat: 22.696525709732366, lng: 113.77490758895874}
        layers = [
            {lat: 22.701479574641432, lng: 113.77007961273193},
            {lat: 22.70053434551827, lng: 113.77007961273193},
            {lat: 22.699806861070243, lng: 113.77014398574829},
            {lat: 22.69896554770695, lng: 113.77041220664978},
            {lat: 22.698752744096225, lng: 113.77050876617432},
            {lat: 22.697550150036502, lng: 113.77108812332153},
            {lat: 22.697144334020724, lng: 113.77144753932953},
            {lat: 22.696911731616034, lng: 113.77196788787842},
            {lat: 22.696812751749544, lng: 113.77207517623901},
            {lat: 22.696560352766348, lng: 113.77216637134552},
            {lat: 22.696179278910655, lng: 113.77221465110779},
            {lat: 22.695842745273563, lng: 113.77219319343567},
            {lat: 22.695422077064663, lng: 113.77196252346039},
            {lat: 22.695065745336073, lng: 113.77162992954254},
            {lat: 22.694852935667242, lng: 113.77153873443604},
            {lat: 22.694268944645266, lng: 113.77156555652618},
            {lat: 22.693873017112807, lng: 113.77158164978027},
            {lat: 22.69355627426305, lng: 113.77157628536224},
            {lat: 22.693145497289194, lng: 113.77158164978027},
            {lat: 22.690136394676433, lng: 113.7725955247879},
            {lat: 22.688517984859622, lng: 113.77332508563995},
            {lat: 22.689106949665618, lng: 113.77556204795837},
            {lat: 22.689705810444458, lng: 113.77683341503143},
            {lat: 22.691200476343152, lng: 113.77870559692383},
            {lat: 22.691185628748833, lng: 113.77870559692383},
            {lat: 22.697030507361383, lng: 113.77775073051453},
            {lat: 22.702405002070343, lng: 113.77691924571991},
            {lat: 22.702063534923486, lng: 113.77458035945892},
            {lat: 22.701474625814846, lng: 113.77007961273193}
        ];


        container.id = 'QQMap';
        container.style.width = '100%';
        container.style.height = '100%';

        map = new qq.maps.Map(container,{
            center:centerLatlng,
            zoom:15,                    //设置整数
            noClear:false,
            mapTypeControl:false,       //地图类型控件的初始启用/停用状态。
            zoomControl:false,          //缩放控件的初始启用/停用状态。
            panControl:false,           //平移控件的初始启用/停用状态。
            scaleControl:false,         //比例尺控件的初始启用/停用状态。
            logoControl:false           //logo控件
        })

    //添加图层
    map.addLayers = (option)=>{

        let points = option.points || [],
            color  = option.color || new qq.maps.Color(51,133,255, 0.3);



        let path = points.map(item=>{
            return new qq.maps.LatLng(item.lat,item.lng);
        })

        let ploygon = new qq.maps.Polygon({

            //多边形是否可点击。
            clickable: true,

            //鼠标在多边形内的光标样式。
            cursor: 'pointer',

            //多边形是否可编辑
            editable:false,

            //填充色
            fillColor:color,

            strokeColor:color,

            strokeDashStyle:'solid',

            strokeWeight:1,

            visible:false,  //隐藏可见性

            map:map,

            path:path,

            zIndex:1000
        })

        return ploygon;
    }

    //会展遮罩层
    let maskLayers = map.addLayers({
        points:layers
    });

    //添加divMarker
    map.enabledAddDivMarker = false;
    map.addDivMarker = (option)=>{

        let name = option.name || '',               //class标识
            content = option.content || '',
            center = option.center || new qq.maps.LatLng(22.695271,113.776747), //new qq.maps.LatLng(22.695271,113.776747)
            decoration = new qq.maps.MarkerDecoration(content, new qq.maps.Point(0, 0));

        let marker = new qq.maps.Marker({
            position:center,
            map:map,
            flat:true,
            visible:true,  //可见性
            decoration:decoration
        })

        //1x1px图片展位
        marker.setIcon('./images/QQpoint.png');


        //marker挂载
        marker.mounted = (callback)=>{

            let demoList = document.getElementsByClassName(name);

            if(demoList.length){

                for(let i=0;i<demoList.length;i++){

                    let d = demoList[i],
                        parents = d.parentNode.parentNode,
                        childs = parents.childNodes;

                    //移除父级限制
                    if(childs.length > 1){
                        parents.style.overflow = 'inherit';
                        parents.removeChild(childs[0]);
                    }
                }

                //添加已挂载标识
                marker.isMounted = true;
                if(!map.enabledAddDivMarker)map.enabledAddDivMarker = true;
            }

            callback && callback();

        }

        //重置内容
        marker.setContent = (content)=>{
            marker.setDecoration(content)
        }

        //重置经纬度
        marker.setLatLng = (latlng)=>{

            let callback = ()=>{
                latlng = new qq.maps.LatLng(latlng.lat,latlng.lng);
                marker.setPosition(latlng);
                marker.setVisible(true);
            }


            if(!marker.isMounted){

                if(marker.isMountedTime){
                    clearTimeout(marker.isMountedTime);
                    marker.isMountedTime = ''
                }

                marker.isMountedTime = setTimeout(()=>{
                    marker.mounted(callback)
                },1000)


            }else{

                callback && callback()
            }

        }

        return marker;
    }

    //marker集
    map.markers = {};

    //实例marker
    let initMarker = ()=>{

        let $marker = map.markers,
            content = `<div class="marker-auto marker-build">
                                <div class="wrap">

                                    <div class="icon">
                                        <img src="./images/qqmarker.png" alt="">
                                    </div>

                                    <div class="label">深圳会展中心</div>

                                </div>
                            </div>`;

        $marker.build = map.addDivMarker({
            name:'marker-build',
            content:content,
            center:centerLatlng
        })

    }

    initMarker();

    //移除腾讯地图&版权
    map.hasLogoAndCopy = true;
    map.removeLogoCopyright = (nodes)=>{

        let parents = nodes.children[0].children[0] || {},
            childNodes = parents.childNodes || [];

        if(childNodes.length > 1){

            for(let i=0;i<childNodes.length;){

                let child = childNodes[i];

                if(i>0){
                    parents.removeChild(child);
                    i -- ;
                }

                i++;
            }

            map.hasLogoAndCopy = false;
        }

    }


    //map挂载回调
    map.mounted = false;
    map.mountedCallee = (nodes)=>{

        //保证地图正常挂载渲染
        if(map.readyTime){
            clearTimeout(map.readyTime);
            map.readyTime = '';
        }

        map.readyTime = setTimeout(()=>{
            map.mounted =  true;
            map.ready && map.ready();
        },1000)

    }

    return {
        map,
        container,
        qqMapEvent,
        maskLayers,
        centerLatlng,
    }
}

/*
创建隐性qq地图用于查询
*/
export function createQueryQQMap() {
    let map,
        container = document.createElement('div'),
        centerLatlng = new qq.maps.LatLng(22.696525709732366,113.77490758895874);

    container.id = 'queryQQMap';
    container.style.width = '0px';
    container.style.height = '0px';
    container.style.zIndex=-9999;
    container.style.visibility ='hidden';

    document.body.appendChild(container);

    map = new qq.maps.Map(container,{
        center:centerLatlng,
        zoom:15,                    //设置整数
        noClear:false,
        mapTypeControl:false,       //地图类型控件的初始启用/停用状态。
        zoomControl:false,          //缩放控件的初始启用/停用状态。
        panControl:false,           //平移控件的初始启用/停用状态。
        scaleControl:false,         //比例尺控件的初始启用/停用状态。
        logoControl:false           //logo控件
    })

    return {
        map:map
    }
}


/*
* 获取验证码
* */
export function getCode(param,callback) {

    let postURL = `${$smssendUrl}?${param}`;

    $request.post(postURL).then(res=>{

        callback && callback(res);
    }).catch(error=>{

        callback && callback({code:1})

    })

}

/*
* 校验验证码 登录
* */
export function verifyCode(param,callback) {

    let postURL = `${$smsVarUrl}?${param}`;

    $request.post(postURL).then(res=>{
        callback && callback(res);
    }).catch(error=>{
        callback && callback({code:1})

    })

}

/*
* 获取 店铺活动列表
* */
export function getActivityDataInfo(callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;


    getAjax.get(HOST + '/api/v1/g_PoiActivity?'+$pDATA,(res)=>{

        let $res= {};

        $res.data = JSON.parse(res);

        callback && callback($res);


    },false)

    // $request.get(HOST + '/api/v1/g_PoiActivity?'+$pDATA).then((res) => {
    //
    //     console.log('异步请求数据',res);
    //
    //     callback && callback(res);
    //
    // }).catch((err)=>{
    //     console.log('获取 店铺活动失败列表');
    // });

}


export function getActivePushInfo(callback) {
    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;


    getAjax.get(HOST + '/api/v1/adPush?'+$pDATA,(res)=>{

        let $res= {};

        $res.data = JSON.parse(res);

        callback && callback($res);


    },false)
}

/*
* 获取主题活动列表
* */
export function getThemeActivity(callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;


    getAjax.get(HOST + '/api/v1/g_themeActivity?'+$pDATA,(res)=>{

        let $res= {};

        $res.data = JSON.parse(res);

        callback && callback($res);


    },false)

    // $request.get(HOST + '/api/v1/g_themeActivity?'+$pDATA).then((res) => {
    //
    //     callback && callback(res);
    //
    // }).catch((err)=>{
    //     console.log('获取主题活动列表失败');
    // });

}


/*
* 更新围观人数(主题，单店)
* */
export let  $countTimer = '' ;
export function getActivityCount($store,$activeArr,$type,$update,$handon,callback) {
    /*
    * $store 数据商店
    * $activeArr 更动活动数据
    * $type 活动类型
    * $update 自动更新 true or false
    * $handon 开启上报 true or false
    * */


    //清空定时器
    if($countTimer){window.clearInterval($countTimer)}

    if(!arguments[0])return;

    $activeArr = $activeArr.concat();//切断联系

    if($type != 1){

        if($activeArr.length > 1){  //多条数据

            if($activeArr[0].length > 0 && $activeArr[1].length > 0){

                $activeArr = $activeArr[0].concat($activeArr[1])

            }else if($activeArr[0].length > 0){

                $activeArr = $activeArr[0]

            }else{

                $activeArr = $activeArr[1]

            }

        }


        if($handon){    //开启上传

            for(let i=0;i< $activeArr.length ;i++){

                let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

                    $pDATA = `${$activeArr[i].id}?sign=${$pluginInfo.sign}`;

                $request.put(HOST + '/api/v1/up_themeCount/'+$pDATA).then((res) => {

                    if(res.data.code==0){

                        let $result = [];

                        for(let j=0;j<$store.state.THEME_ACTIVITY_DATA.length;j++){

                            $result = $store.state.THEME_ACTIVITY_DATA[j].filter((item,index)=>{

                                if(item.id == $activeArr[i].id){

                                    item.count = res.data.result;

                                }

                                return item.id == $activeArr[i].id
                            })

                        }

                        callback ? callback && callback($result) :''
                    }

                }).catch((err)=>{
                    console.log('更新主题活动围观人数失败');
                });
            }
        }


    }

    else{//单店(单条)

        if($handon){

            let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

                $pDATA = `${$activeArr[0].id}?sign=${$pluginInfo.sign}`;

            $request.put(HOST + '/api/v1/adPush/'+$pDATA).then((res) => {

                if(res.data.code==0){

                    let $result = [];

                    $result = $store.state.ACTIVITY_DATA.filter((item,index)=>{

                        if(item.id == $activeArr[0].id){

                            item.count = res.data.result;
                            $activeArr[0].count = item.count;
                        }

                        return item.id == $activeArr[0].id
                    })

                    callback ? callback && callback($result) :''
                }

            }).catch((err)=>{
                console.log('更新商铺活动围观人数失败');
            });

        }

    }


    if($activeArr.length == 0)return;

    if($update){    //开启定时器(每3s更新一下状态、围观人数)

        // $countTimer = setInterval(()=>{

            if($type != 1){     //主题活动

                getThemeActivity((res)=>{

                    if(res.data.code == 0){

                        for(var i=0;i<$activeArr.length;i++){

                            let $current = res.data.result.filter((item)=>{
                                return item.id == $activeArr[i].id;
                            })

                            if($current.length > 0){

                                //修改状态与计数
                                for(var j=0;j<$store.state.THEME_ACTIVITY_DATA.length;j++){

                                    $store.state.THEME_ACTIVITY_DATA[j].map((item,index)=>{

                                        if(item.id == $current[0].id){

                                            item.count = $current[0].count;

                                            let $status = 0;

                                            if($current[0].status == 1){   //下线(下线数据不要)

                                                // $status = 2;
                                                $store.state.THEME_ACTIVITY_DATA[j].splice(index,1);

                                            }else{

                                                $status =0;//即将开始

                                                if(new Date().getTime() - $current[0].endTime >= 0){   //过期
                                                    $status = 2;
                                                }else if(new Date().getTime() - $current[0].startTime < 0){   //正在进行中
                                                    $status = 1;
                                                }

                                            }

                                            item.status = $status;



                                        }

                                    })

                                }

                                //数据重排防止交叉
                                let $data1 =  $store.state.THEME_ACTIVITY_DATA[0].filter(item =>{
                                    return item.status == 2;
                                })

                                let $data2 = $store.state.THEME_ACTIVITY_DATA[1].filter(item =>{
                                    return item.status < 2;
                                })


                                //重组
                                if($data1.length > 0){
                                    $store.state.THEME_ACTIVITY_DATA[1] =
                                        $store.state.THEME_ACTIVITY_DATA[1].length >0 ? $store.state.THEME_ACTIVITY_DATA[1].concat($data1):$data1

                                }

                                if($data2.length > 0){

                                    $store.state.THEME_ACTIVITY_DATA[0] =
                                        $store.state.THEME_ACTIVITY_DATA[0].length >0 ? $store.state.THEME_ACTIVITY_DATA[0].concat($data2):$data2;


                                }

                                //筛出
                                $store.state.THEME_ACTIVITY_DATA[0].map((item,index)=>{
                                    if(item.status >= 2){$store.state.THEME_ACTIVITY_DATA[0].splice(index,1)}
                                })

                                //按活动状态排序
                                if($store.state.THEME_ACTIVITY_DATA[0].length > 1){
                                    $store.state.THEME_ACTIVITY_DATA[0].sort((v1,v2)=>{
                                        return v1.status - v2.status
                                    })
                                }


                                $store.state.THEME_ACTIVITY_DATA[1].map((item,index)=>{
                                    if(item.status < 2){$store.state.THEME_ACTIVITY_DATA[1].splice(index,1)}
                                })


                            }

                        }

                    }
                })

            }

            else{  //店铺活动

                getActivityDataInfo((res)=>{

                    if(res.data.code ==0){

                        let $current = res.data.result.filter((item)=>{return item.id == $activeArr[0].id})

                        if($current && $current.length >0){

                            $store.state.ACTIVITY_DATA.map((item,index)=>{

                                if($current[0].id == item.id){

                                    item.count = $current[0].count;

                                    //修改状态
                                    let $status = 0; //正在进行中

                                    //下线活动不需要
                                    if(!item.adStatus){
                                        $store.state.ACTIVITY_DATA.splice(index,1);
                                    }

                                    item.status = $status;

                                }
                            })

                        }

                    }

                })
            }

        // },3000)
    }

}


/*
* 获取 poi 详情列表
* */
export function getPoiDetailDataInfo(callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),
        $pDATA = `sign=${$pluginInfo.sign}`;

    $request.get(HOST + '/api/v1/g_PoiInfo?' + $pDATA).then((res) => {

        callback && callback(res);

    }).catch((err)=>{
        console.log('获取POI详情列表失败');
    });

}


/*
* 获取收藏夹列表
* */
export function getCollectData($this,callback) {

    if(mapFunManger.collectAndFoots === 2){

        let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

            $pDATA = `sign=${$pluginInfo.sign}&phone=${$pluginInfo.phone}`;

        $request.post(HOST+'/api/v1/g_Collect?'+$pDATA).then((res)=>{

            callback && callback(res);

        }).catch((err)=>{

            // $this.$message.info('获取收藏夹列表失败')
            console.log('获取收藏夹列表失败');

        })

    }

    else if(mapFunManger.collectAndFoots === 1){
        //本地数据库查询
        let buildId = $this.$store.state.mapStore.plugInfo.buildingId,
            name = buildId + '_collectDataBase';


        let collectDataBase = window.localStorage.getItem(name) || JSON.stringify([]);

        //同步线上组装数据
        let res = {
            data:{
                code:0,
                result:JSON.parse(collectDataBase)
            }
        }

        callback && callback(res);
    }

}


/*
* 添加收藏夹列表
* */

export function addCollectData($this,$item,callback) {


    if(mapFunManger.collectAndFoots === 2){

        let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

            $pDATA = `sign=${$pluginInfo.sign}`,

            $parems = {
                buildingId:$pluginInfo.buildingId,
                phone:$pluginInfo.phone,
                poi:JSON.stringify($item)
            }


        if(!$pluginInfo.phone){
            $this.bus.$emit('LoginCallback',{status:1});
            return;
        }

        // console.log('$parems',$parems);
        $request.post(HOST+'/api/v1/add_Collect?'+$pDATA,$parems).then((res)=>{

            if(res.data.code == 1){
                $this.$message.info('请先登录');
                $this.bus.$emit('LoginCallback',{status:1});

            }else{
                callback && callback(res);
            }

        }).catch((err)=>{

            $this.$message.info('添加收藏夹失败')
            // console.log('添加收藏夹失败');
        })

    }else if(mapFunManger.collectAndFoots === 1){
        //本地数据库查询
        let buildId = $this.$store.state.mapStore.plugInfo.buildingId,
            name = buildId + '_collectDataBase';

        let collectDataBase = window.localStorage.getItem(name) || JSON.stringify([]);

        collectDataBase = JSON.parse(collectDataBase);

        //配置id
        let isTure = collectDataBase.some(item=>{
            return item.POI_ID == $item.POI_ID
        })

        if(!isTure){

            //获取最大id
            let $id = 0;
            if(collectDataBase.length){
                if(collectDataBase.length == 1){
                    $id = collectDataBase[0].id;
                }else{
                    $id = collectDataBase.sort((v1,v2)=>{
                        return v2.id - v1.id;
                    })[0].id;
                }
            }


            //组装推送数据
            let obj = {
                buildingId:buildId,
                createdTime:'',
                id:$id+1,
                phone:'',
                poi:JSON.stringify($item)
            }

            collectDataBase.push(obj);

            window.localStorage.setItem(name,JSON.stringify(collectDataBase))
        }

        callback && callback('添加成功');
    }
}

/*
* 删除收藏夹列表
* */
export function deleteCollectData($this,$id,callback) {

    if(mapFunManger.collectAndFoots === 2){

        let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

            $pDATA = `sign=${$pluginInfo.sign}`;

        $request.delete(HOST+'/api/v1/del_Collect/'+$id+'?'+$pDATA).then((res)=>{

            if(res.data.code == 1){

                $this.$message.info('请先登录');
                $this.bus.$emit('LoginCallback',{status:1});

            }else{
                callback && callback(res);
            }

        }).catch((err)=>{

            $this.$message.info('删除列表失败')
            // console.log('删除列表失败');
        })

    }

    else if(mapFunManger.collectAndFoots === 1){

        //本地数据库查询
        let buildId = $this.$store.state.mapStore.plugInfo.buildingId,
            name = buildId + '_collectDataBase';

        let collectDataBase = window.localStorage.getItem(name) || JSON.stringify([]);

        collectDataBase = JSON.parse(collectDataBase);

        collectDataBase = collectDataBase.filter(item=>{
            return item.id != $id;
        })

        window.localStorage.setItem(name,JSON.stringify(collectDataBase));

        callback && callback('删除成功');
    }

}


/*
* 获取历史足迹列表
* */
export function getHistoryFootData($this,callback) {

    if(mapFunManger.collectAndFoots === 2){

        let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

            $pDATA = `sign=${$pluginInfo.sign}&phone=${$pluginInfo.phone}`;

        $request.post(HOST+'/api/v1/g_Footprint?'+$pDATA).then((res)=>{

            callback && callback(res);

        }).catch((err)=>{

            // $this.$message.info('获取历史足迹列表失败')
            console.log('获取历史足迹列表失败');

        })

    }else if(mapFunManger.collectAndFoots === 1){

        //本地数据库查询
        let buildId = $this.$store.state.mapStore.plugInfo.buildingId,
            name = buildId + '_footsDataBase';

        let footsDataBase = window.localStorage.getItem(name) || JSON.stringify([]);

        //同步线上组装数据
        let res = {

            data:{
                code:0,
                result:JSON.parse(footsDataBase)
            }

        }

        callback && callback(res);

    }

}

/*
* 添加历史足迹列表
* */
export function addHistoryFootData($this,$item,callback) {

    if(mapFunManger.collectAndFoots === 2){

        let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

            $pDATA = `sign=${$pluginInfo.sign}`,

            $parems = {
                buildingId:$pluginInfo.buildingId,
                phone:$pluginInfo.phone,
                endPoi:JSON.stringify($item.endPoi),
                startPoi:JSON.stringify($item.startPoi),
            }

        // console.log('$parems',$parems);

        $request.post(HOST+'/api/v1/add_Footprint?'+$pDATA,$parems).then((res)=>{

            if(res.data.code == 1){
                $this.$message.info('请先登录');
                $this.bus.$emit('LoginCallback',{status:1});
            }else{
                callback && callback(res);
            }

        }).catch((err)=>{

            $this.$message.info('添加历史足迹列表失败')
            // console.log('添加收藏夹失败');
        })


    }else if(mapFunManger.collectAndFoots === 1){

        let buildId = $this.$store.state.mapStore.plugInfo.buildingId,
            name = buildId + '_footsDataBase';
        let footsDataBase = window.localStorage.getItem(name) || JSON.stringify([]);
        footsDataBase = JSON.parse(footsDataBase);

        //获取最大id
        let $id = 0;
        if(footsDataBase.length){
            if(footsDataBase.length == 1){
                $id = footsDataBase[0].id;
            }else{
                $id = footsDataBase.sort((v1,v2)=>{
                    return v2.id - v1.id;
                })[0].id;
            }
        }

        //组装推送数据
        let obj = {
            buildingId:buildId,
            createdTime:'',
            id:$id+1,
            phone:'',
            startPoi:JSON.stringify($item.startPoi),
            endPoi:JSON.stringify($item.endPoi)
        }

        footsDataBase.push(obj);
        window.localStorage.setItem(name,JSON.stringify(footsDataBase));

        callback && callback('添加成功');
    }


}

/*
* 删除历史足迹列表
* */
export function deleteHistoryFootData($this,$id,callback) {

    if(mapFunManger.collectAndFoots === 2){
        let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

            $pDATA = `sign=${$pluginInfo.sign}`;

        $request.delete(HOST+'/api/v1/del_Footprint/'+$id+'?'+$pDATA).then((res)=>{

            if(res.data.code == 1){

                $this.$message.info('请先登录');
                $this.bus.$emit('LoginCallback',{status:1});
            }else{
                callback && callback(res);
            }

        }).catch((err)=>{

            $this.$message.info('删除历史足迹列表失败')
            // console.log('删除列表失败');
        })
    }

    else if(mapFunManger.collectAndFoots ===1){
        //本地数据库查询
        let buildId = $this.$store.state.mapStore.plugInfo.buildingId,
            name = buildId + '_footsDataBase';

        let footsDataBase = window.localStorage.getItem(name) || JSON.stringify([]);

        footsDataBase = JSON.parse(footsDataBase);

        footsDataBase = footsDataBase.filter(item=>{
            return item.id != $id;
        })

        window.localStorage.setItem(name,JSON.stringify(footsDataBase));

        callback && callback('删除成功');
    }
}


/*
* 获取车牌列表
* */
export function getCarData($this,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}&phone=${$pluginInfo.phone}`;

    if($pluginInfo.phone){
        $request.get(HOST+'/api/v1/g_CarPlate?'+$pDATA).then((res)=>{

            callback && callback(res);

        }).catch((err)=>{

            // $this.$message.info('获取云车牌列表失败')
            console.log('获取云车牌列表失败');

        })
    }

}



/*
* 添加云车牌号
* */
export function addCarData($this,$item,$ID,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`,

        $parems = {
            buildingId:$pluginInfo.buildingId,
            phone:$pluginInfo.phone,
            plateArray:JSON.stringify($item),
        }

    if($ID){$parems.id = $ID}

    $request.post(HOST+'/api/v1/up_CarPlate?'+$pDATA,$parems,{

        headers: {
            'Content-Type': 'application/json'
        }

    }).then((res)=>{

        if(res.data.code == 1){

            $this.$message.info(res.data.message);


        }else{
            callback && callback(res);
        }

    }).catch((err)=>{

        $this.$message.info('添加云车牌号失败')
        // console.log('添加云车牌号失败');
    })

}



//查车
export function findCarData($this,$param,callback) {
    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}&plateNo=${$param.carID}`;

    $request.post(HOST + '/api/v1/queryCar?' + $pDATA).then((res)=>{
        // console.log('查车',res);

        if(res.data.code == 0 && res.data.result){
            callback && callback(res.data.result);
        }else{
            callback && callback();
        }
    }).catch((err)=>{
        callback && callback();
    })
}


/*
* 获取热词列表
* */
export function getHotWords($this,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}&language=1`; //1中文 2英文

    $request.get(HOST+'/api/v1/g_HotWord?'+$pDATA).then((res)=>{

        // console.log('热词',res);

        callback && callback(res);

    }).catch((err)=>{

        // $this.$message.info('获取热词列表失败')
        console.log('获取热词列表失败');

    })

}


/*
* 上传搜索词汇
* */
export function upHotWords($this,$value,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`,

        $param ={word:$value,language:1};



    $request.post(HOST+'/api/v1/g_HotWord?'+$pDATA,$param).then((res)=>{
        console.log('上传热词',res);

        callback && callback(res);

    }).catch((err)=>{

        // $this.$message.info('获取热词列表失败')
        console.log('获取热词列表失败');

    })

}


/*
* 获取POI活动列表
* */
export function getPOIActivity($this,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;

    $request.get(HOST+'/api/v1/g_PoiActivity?'+$pDATA).then((res)=>{

        callback && callback(res);

    }).catch((err)=>{

        // $this.$message.info('获取POI活动列表失败')
        console.log('获取POI活动列表失败');
    })

}

/*
* 获取POI详情列表信息
* */
export function getPOIDetail($this,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;

    $request.get(HOST+'/api/v1/g_PoiInfo?'+$pDATA).then((res)=>{

        callback && callback(res);

    }).catch((err)=>{

        // $this.$message.info('获取POI详情列表信息失败')
        console.log('获取POI详情列表信息失败');
    })

}


/*
* 获取推荐列表信息
* */
export function getRecommendData($this,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;


    getAjax.get(HOST+'/api/v1/g_Recommend?'+$pDATA,(res)=>{

        let $res= {};

        $res.data = JSON.parse(res);

        callback && callback($res);

    },false)

    // $request.get(HOST+'/api/v1/g_Recommend?'+$pDATA).then((res)=>{
    //
    //     console.log('res',res);
    //
    //     callback && callback(res);
    //
    // }).catch((err)=>{
    //
    //     // $this.$message.info('获取推荐列表信息失败')
    //     console.log('获取推荐列表信息失败');
    // })

}


/**
 * 获取区域触发点位信息
 * */
export function getNavAreaPoint($this,callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;

    $request.get(HOST+'/api/v1/g_AreaTrigger?'+$pDATA).then((res)=>{

        callback && callback(res);

    }).catch((err)=>{

        // $this.$message.info('获取区域触发点位列表信息失败')
        console.log('获取区域触发点位列表信息失败');
    })

}


/**
 * 获取母婴室情况
 * */
export  function getMomCare($this,callback) {

    // let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo'));
    //
    //     // $pDATA = `sign=${$pluginInfo.sign}`;
    //
    //
    // getAjax.get(HOST+'/api/v1/nursingRoom/findAll',(res)=>{
    //
    //
    //     res = JSON.parse(res);
    //
    //     if(res.code == 0){
    //
    //         let $res = {};
    //         $res.data = res;
    //         callback && callback($res);
    //
    //     }else{
    //
    //         console.log('哺乳室数据失败');
    //     }
    //
    // })


    // $request.get(HOST+'/api/v1/nursingRoom/findAll').then((res)=>{
    //
    //     callback && callback(res);
    //
    // }).catch((err)=>{
    //     console.log('哺乳室数据失败');
    //
    // })

}


//空车位地图
export function findCarParking_Null($this,callback) {

    // $request.get(HOST + '/api/v1/remainingParkingSpace').then((res)=>{
    //     // console.log('查车空车位',res);
    //     if(res.data.code == 0){
    //         callback && callback(res);
    //     }
    // }).catch((err)=>{
    //     $this.$message.info('查找空车位失败~~');
    //     $this.$message.load(false);
    //     $this.$BRT.$urlParam.findNullPark.status = false;
    // })

    let pageSize = 500,
        pageIndex = 1,  //索引1与0是一致的
        endPOI = '',
        callee = (pageIndex)=>{

            $request.get(HOST + `/api/v1/queryParkingSpace?pageSize=${pageSize}&recordStart=${pageIndex}&status=0`).then(res=>{

                if(res.data.code==0){

                    let result = res.data.result;

                    if(endPOI && endPOI == result[result.length-1]){
                        setTimeout(()=>{
                            $this.$message.info('空车位已全部加载完成~~');
                        },3000)
                        return;
                    }

                    //标记最后一位
                    endPOI = result[result.length-1];

                    callback && callback(res);

                    pageIndex++;

                    //异步防止影响操作
                    setTimeout(()=>{
                        callee(pageIndex);
                    },0)

                }else{
                    console.log('获取空车位失败');
                }

            }).catch(err=>{
                $this.$message.info('查找空车位失败~~');
                $this.$message.load(false);
                $this.$BRT.$urlParam.findNullPark.status = false;
            })
        };

        $this.$message.info('正在为您分批次查询空车位哟~~');

        callee(pageIndex)
}

//获取展馆数据
export function getHallData(floor,callback) {

    let axiosUrl = `${HOST}/api/v1/getDestinationData`;
    if(floor)axiosUrl += `?floorName=${floor}`;

    $request.get(axiosUrl).then(res=>{
        console.log('获取展馆数据',res);
        if(res.data.code==0){
            callback && callback(res.data.result)
        }else{
            callback && callback('暂无展馆数据','err')
        }
    }).catch(err=>{
        callback && callback('暂无展馆数据','err')
        console.log('获取展馆数据失败',err);
    })
}


//获取空车位数量
export function getParkNumber(floor,callback) {

    let axiosUrl = `${HOST}/api/v1/getFreeParkingNumber`;

    if(floor)axiosUrl += `?floorName=${floor}`;

    $request.get(axiosUrl).then(res=>{

        console.log(`${floor} 空车位数量`,res);

        if(res.data.code==0){
            callback && callback(res.data.result)
        }else{
            callback && callback(`${floor} 空车位查询失败`,'err')
        }
    }).catch(err=>{
        callback && callback(`${floor} 空车位查询失败`,'err')
        console.log(`${floor} 空车位查询失败`,err);
    })
}

//获取分配空车位
export function getHallPark(floor,poiId,callback) {

    let axiosUrl = `${HOST}/api/v1/getFreeParkingSpace`;

    if(floor)axiosUrl += `?floorName=${floor}`;

    if(poiId)axiosUrl += `&poiId=${poiId}`;

    $request.get(axiosUrl)
        .then(res=>{

        console.log(`号馆分配空车位`,res);

        if(res.data.code==0){
            callback && callback(res.data.result)
        }else{
            callback && callback(`号馆分配空车位失败`,'err')
        }
    })
        .catch(err=>{
        callback && callback(`号馆分配空车位失败`,'err')
        console.log(`号馆分配空车位失败`,err);
    })
}

//查询分配空车位状态
export function getQueryParking(poiId,callback) {

    let axiosUrl = `${HOST}/api/v1/queryParkingSpaceStatus`;

    if(poiId)axiosUrl += `?spaceNo=${poiId}`;

    $request.get(axiosUrl)
        .then(res=>{
            //true 未占用 false 已占用

            console.log(`号馆分配空车位状态`,res);

            if(res.data.code==0){
                callback && callback(res.data.result)
            }else{
                callback && callback(`号馆分配空车位超时`,'err')
            }
        })
        .catch(err=>{
            callback && callback(`号馆分配空车位状态查询失败`,'err')
            console.log(`号馆分配空车位状态查询失败`,err);
        })
}


//创建房间
export function toCreateRoom(param,callback) {

    $request.post(`${WXUSERHOST}/api/createdRoom`,
        Qs.stringify({buildingId:param.buildingId, token:param.token}),
        {'headers': {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}}).then(res=>{
        console.log('创建房间',res);
        if(res.data.code === 0){
            callback && callback(res.data.result);
        }else{
            callback && callback('创建房间失败','err')
        }
    }).catch(err=>{
        callback && callback('创建房间失败','err')
    })

}


//获取微信用户信息
export function getWXUserInfo(openId,callback) {

    $request.post(`${WXUSERHOST}/api/getWxUserInfo`,Qs.stringify({openid:openId}),{'headers': {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}}).then(res=>{

        console.log('获取微信用户信息',res);

        /**模拟数据**/
        // res.data.result = {
        //     nickname:'测试数据',
        //     headimgurl:require('@/assets/headImg.png'),
        //     openid:''
        // };


        if(res.data.code==0 && res.data.result){

            let result = res.data.result;

            //替换htpps头像
            if(res.data.result.headimgurl){
                res.data.result.headimgurl = res.data.result.headimgurl.replace('http://','https://')
            }
            // result.ctime = +new Date() - 0 + (1 * 24 * 60 * 60 * 1000); //存一天
            callback && callback(result);

        }else{
            callback && callback('获取微信用户信息失败','err')
        }

    }).catch(err=>{
        callback && callback('获取微信用户信息失败','err')
    })

}


//获取热门展馆、区域数据
export function getHotRegion(callback) {
    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),

        $pDATA = `sign=${$pluginInfo.sign}`;

    $request.get(HOST+'/api/v1/hotData?'+$pDATA).then((res)=>{

        // console.log('热门展馆、区域数据',res);
        if(res.data.code == 0){

            let $result = Object.assign({},res.data.result);

            if($result.pavilion && $result.pavilion.length){
                $result.pavilion = $result.pavilion.filter(item=>{
                    item.name = item.name || item.poiName;
                    return !!item.name
                });
            }


            if($result.region && $result.region.length){
                $result.region = $result.region.filter(item=>{
                    item.name = item.name || item.poiName;
                    return !!item.name
                });
            }

            callback && callback($result)
        }
        else {
            callback && callback('数据获取失败','err')
        }

    }).catch((err)=>{
        callback && callback('数据获取失败','err')
    })
}


//获取逃生通道开启状态
export function getEscapeRoute(callback) {

    let $pluginInfo = JSON.parse(sessionStorage.getItem('pluginInfo')),
        $pDATA = `sign=${$pluginInfo.sign}`;


    $request.get(HOST+'/api/v1/g_Settings/exigency?'+$pDATA).then((res)=>{

        // console.log('获取逃生通道开启状态',res);
        if(res.data.code == 0){

            let $result = res.data.result;

            callback && callback($result)
        }
        else {
            callback && callback('数据获取失败','err')
        }

    }).catch((err)=>{
        callback && callback('数据获取失败','err')
    })

}
